// import React, { useState ,useEffect } from 'react';
// import "./App.css";
// import TopBar from "./Components/topbar/topbar";
// import Hero from "./Components/landing_pages/hero";
// import AboutUs from "./Components/about_us_page/aboutUs";
// import WhoWeAre from "./Components/whoWeAre/whoWeAre";
// import Feedback from "./Components/feedback/feedback";
// import WhyUs from "./Components/whyUs/whyUs";
// import Solutions_and_services from "./Components/solutions_and_services/solutions_and_service";
// import Contact_us from "./Components/contact_us/contact_us";
// import Footer from "./Components/Footer/Footer";
// import Tie_ups from "./Components/tie_ups/tie_ups";
// import Achievements from "./Components/achievements/achievements";
// import Awards from "./Components/awards/awards";

// import AboutUsPage from "./Components/extraPages/hcm/AboutUsPage";
// import ServicesPage from "./Components/extraPages/hcm/ServicesPage";
// import BlogEndUser from "./Components/Blogs_main/blogs_end_user";
// import AdminLogin from "./Components/admin_main/admin_login";
// import AdminBlogList from "./Components/admin_table_list/admin_blog_main";
// import BlogIndiView from "./Components/Blogs_main/blog_indi_view_main";
// import AdminMenu from "./Components/admin_main/admin_menu";
// import BlogStepper from "./Components/blog_stepper/create_blog-stepper";
// import EditBlogStepper from "./Components/blog_stepper/edit_blog_stepper";
// import DevelopmentServices from "./Components/extraPages/developmentServices/developmentServices";
// import Sap from "./Components/extraPages/sap/sap";
// import AwardsFull from "./Components/extraPages/awards/awards_full";
// import Intelligent from "./Components/extraPages/intelligent/intelligent";
// import Kronos from "./Components/extraPages/kronos/kronos";
// import Cwfm from "./Components/extraPages/cwfm/cwfm";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import PrivacyPolicy from "./Components/extraPages/privacyPolicy/privacyPolicy";

// import BookDemoModal from './Components/react_modal/reactModal'; // Adjust the import path if necessary
// import AdminBlogMain from './Components/admin_table_list/admin_blog_main';
// import MetricsSection from './Components/metrics/metrics';
// import UkgOfferings from './Components/ukg_offerings/ukg_offerings';
// import PartnershipBadges from './Components/partners/partners';
// import TrustedBrands from './Components/trusted_brands/trusted_brands';
// import ContactSection from './Components/contact/contact';
// import FooterSec from './Components/footer_sec/footer_sec';
// import VYNPage from './Components/vyn_page/vyn_page';
// import UKGServicePage from './Components/ukg_services_page/ukg_services_page';
// import AboutUsPage2 from './Components/about_us_page2/about_us_page2';

// import Preloader from './Components/preloader/preloader';
// import { useLayoutEffect } from 'react';

// function App() {
//   const [modalIsOpen, setModalIsOpen] = useState(false);

//   const openModal = () => {
//     setModalIsOpen(true);
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//   };

//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Hide preloader when all assets are loaded
//     const handleLoad = () => {
//       setLoading(false);
//     };

//     window.addEventListener('load', handleLoad);

//     // Fallback in case load event doesn't fire
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 3000); // 3 seconds max loading time

//     return () => {
//       window.removeEventListener('load', handleLoad);
//       clearTimeout(timer);
//     };
//   }, []);

//   if (loading) {
//     return <Preloader />;
//   }

//   return (
//     <div>
//       <Router>
//         <Routes>
//           <Route path="/" element={<HomePage openModal={openModal} />} />
//           <Route path="/aboutUs" element={<AboutUsPage2 />} />
//           {/* <Route path="/services" element={<ServicesPage openModal={openModal} />} /> */}
//           <Route path="/vyn" element={<VYNPage openModal={openModal} />} />
//           <Route path="/services" element={<UKGServicePage openModal={openModal} />} />
//           <Route path="/blogUser" element={<BlogEndUser openModal={openModal} />} />
//           <Route path="/adminLogin" element={<AdminLogin openModal={openModal} />} />
//           <Route path="/adminBlogList" element={<AdminBlogMain />} />
//           <Route path="/blogIndiView/:id" element={<BlogIndiView />} />
//           <Route path="/adminMenu" element={<AdminMenu openModal={openModal} />} />
//           <Route path="/blogCreate" element={<BlogStepper />} />
//           <Route path="/editBlog" element={<EditBlogStepper />} />
//           <Route path="/devServices" element={<DevelopmentServices />} />
//           <Route path="/sap" element={<Sap />} />
//           <Route path="/AwardsFull" element={<AwardsFull />} />
//           <Route path="/intelligent" element={<Intelligent />} />
//           <Route path="/kronos" element={<Kronos />} />
//           <Route path="/cwfm" element={<Cwfm />} />
//           <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
//         </Routes>
//       </Router>
//       <BookDemoModal
//         isOpen={modalIsOpen}
//         onRequestClose={closeModal}
//       />
//     </div>
//   );
// }

// const HomePage = ({ openModal }) => (
//   <div>
//     <TopBar />
//     <Hero openModal={openModal} />
//     <Feedback openModal={openModal} />
//     {/* <Tie_ups /> */}
//     {/* <Awards/> */}
//     <MetricsSection />
//     <UkgOfferings />
//     <PartnershipBadges />
//     <TrustedBrands />
//     {/* <AboutUs /> */}
//     {/* <Achievements /> */}
//     {/* <WhoWeAre openModal={openModal} /> */}
//     {/* <WhyUs /> */}
//     {/* <Solutions_and_services openModal={openModal}  /> */}
//     <ContactSection />
//     <FooterSec />
//     {/* <Footer /> */}
//   </div>
// );

// export default App;


import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Components
import TopBar from './Components/topbar/topbar';
import Hero from './Components/landing_pages/hero';
import Feedback from './Components/feedback/feedback';
import MetricsSection from './Components/metrics/metrics';
import UkgOfferings from './Components/ukg_offerings/ukg_offerings';
import PartnershipBadges from './Components/partners/partners';
import TrustedBrands from './Components/trusted_brands/trusted_brands';
import ContactSection from './Components/contact/contact';
import FooterSec from './Components/footer_sec/footer_sec';

import AboutUsPage2 from './Components/about_us_page2/about_us_page2';
import VYNPage from './Components/vyn_page/vyn_page';
import UKGServicePage from './Components/ukg_services_page/ukg_services_page';
import PartnerVyn from './Components/partner_vyn/partner_vyn';
import BlogEndUser from './Components/Blogs_main/blogs_end_user';
import AdminLogin from './Components/admin_main/admin_login';
import AdminBlogMain from './Components/admin_table_list/admin_blog_main';
import BlogIndiView from './Components/Blogs_main/blog_indi_view_main';
import AdminMenu from './Components/admin_main/admin_menu';
import BlogStepper from './Components/blog_stepper/create_blog-stepper';
import EditBlogStepper from './Components/blog_stepper/edit_blog_stepper';
import DevelopmentServices from './Components/extraPages/developmentServices/developmentServices';
import Sap from './Components/extraPages/sap/sap';
import AwardsFull from './Components/extraPages/awards/awards_full';
import Intelligent from './Components/extraPages/intelligent/intelligent';
import Kronos from './Components/extraPages/kronos/kronos';
import Cwfm from './Components/extraPages/cwfm/cwfm';
import PrivacyPolicy from './Components/extraPages/privacyPolicy/privacyPolicy';

import BookDemoModal from './Components/react_modal/reactModal';
import Preloader from './Components/preloader/preloader';

import imgBg from "./img/des_sec/wiki_2_bg.svg"
import ContactModal from './Components/contact_us/contact_us';
import PartnerDemoModal from './Components/react_modal/partnerDemoModal';

// RouteWrapper to handle loading on route change
// const RouteWrapper = ({ children }) => {
//   const location = useLocation();
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     setLoading(true);
//     const timer = setTimeout(() => setLoading(false), 2000); // Preloader shown for 2 seconds
//     return () => clearTimeout(timer);
//   }, [location.pathname]);

//   if (loading) return <Preloader />;
//   return children;
// };

const RouteWrapper = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const img = new Image();
    img.src = {imgBg}; // update with your actual image path

    const handleLoad = () => {
      // Add a slight delay if you still want a smoother experience
      setTimeout(() => setLoading(false), 300); 
    };

    img.onload = handleLoad;
    img.onerror = handleLoad; // fallback if image fails to load

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [location.pathname]);

  if (loading) return <Preloader />;
  return children;
};


// HomePage with all landing content
const HomePage = ({ openModal,openContactModal }) => (
  <div>
    <TopBar />
    <Hero openModal={openModal} />
    <Feedback openModal={openModal} />
    <MetricsSection />
    <UkgOfferings openContactModal={openContactModal} />
    <PartnershipBadges />
    <TrustedBrands />
    <ContactSection openContactModal={openContactModal}  />
    <FooterSec />
  </div>
);

function App() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const [contactModalIsOpen, setContactModalIsOpen] = useState(false);
  const openContactModal = () => setContactModalIsOpen(true);
  const closeContactModal = () => setContactModalIsOpen(false);

  const [partnerModalIsOpen, setPartnerModalIsOpen] = useState(false);
  const openPartnerModal = () => setPartnerModalIsOpen(true);
  const closePartnerModal = () => setPartnerModalIsOpen(false);

  return (
    <Router>
      <RouteWrapper>
        <Routes>
          <Route path="/" element={ <HomePage 
      openModal={openModal} 
      openContactModal={openContactModal}  // Add this
    />} />
          <Route path="/aboutUs" element={<AboutUsPage2 openContactModal={openContactModal} />} />
          <Route path="/vyn" element={<VYNPage openContactModal={openContactModal} />} />
          <Route path="/services" element={<UKGServicePage openContactModal={openContactModal} />} />
          <Route path="/partnerVyn" element={<PartnerVyn openPartnerModal={openPartnerModal} />} />
          <Route path="/blogUser" element={<BlogEndUser openModal={openModal} />} />
          <Route path="/adminLogin" element={<AdminLogin openModal={openModal} />} />
          <Route path="/adminBlogList" element={<AdminBlogMain />} />
          <Route path="/blogIndiView/:id" element={<BlogIndiView />} />
          <Route path="/adminMenu" element={<AdminMenu openModal={openModal} />} />
          <Route path="/blogCreate" element={<BlogStepper />} />
          <Route path="/editBlog" element={<EditBlogStepper />} />
          <Route path="/devServices" element={<DevelopmentServices />} />
          <Route path="/sap" element={<Sap />} />
          <Route path="/AwardsFull" element={<AwardsFull />} />
          <Route path="/intelligent" element={<Intelligent />} />
          <Route path="/kronos" element={<Kronos />} />
          <Route path="/cwfm" element={<Cwfm />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        </Routes>

        <BookDemoModal isOpen={modalIsOpen} onRequestClose={closeModal} />
        <PartnerDemoModal isOpen={partnerModalIsOpen} onRequestClose={closePartnerModal} />
        <ContactModal isOpen={contactModalIsOpen} onClose={closeContactModal} />
      </RouteWrapper>
    </Router>
  );
}

export default App;
